export var ReviewFormSource;
(function(ReviewFormSource) {
    ReviewFormSource["brand_review_source_unknown"] = "brand_review_source_unknown";
    ReviewFormSource["logged_out_brand_page"] = "logged_out_brand_page";
    ReviewFormSource["brand_page"] = "brand_page";
    ReviewFormSource["product_page"] = "product_page";
    ReviewFormSource["order_page"] = "order_page";
    ReviewFormSource["orders_page_top_banner"] = "orders_page_top_banner";
    ReviewFormSource["orders_page_write_review_cta"] = "orders_page_write_review_cta";
    ReviewFormSource["orders_page_edit_review_cta"] = "orders_page_edit_review_cta";
    ReviewFormSource["orders_page_view_review_cta"] = "orders_page_view_review_cta";
    ReviewFormSource["my_reviews_page"] = "my_reviews_page";
    ReviewFormSource["brand_reviews_page"] = "brand_reviews_page";
    ReviewFormSource["packaging_slip"] = "packaging_slip";
    ReviewFormSource["review_brand_email"] = "review_brand_email";
    ReviewFormSource["review_brand_reminder_email"] = "review_brand_reminder_email";
    ReviewFormSource["messenger_review_request"] = "messenger_review_request";
    ReviewFormSource["brand_personal_link"] = "brand_personal_link";
})(ReviewFormSource || (ReviewFormSource = {}));
